import React from "react";
import { Box, Chip, Grid, Link, Paper, Stack, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { rootClientPath } from "../../../../../platform/util/link";
import { useSelectedBusiness } from "../../../../../platform/redux/store";

const StaffProfile = (props: any) => {
  const selectedBusiness = useSelectedBusiness();
  const businessUrl = selectedBusiness?.businessBasic?.url || "";
  const incomingStaff = props.staff;
  const latestStaff =
    (selectedBusiness?.businessStaffs || []).find(
      (s: any) => Number(s?.id) === Number(incomingStaff?.id)
    ) || incomingStaff;
  const staff = {
    ...incomingStaff,
    ...latestStaff,
    user: { ...(incomingStaff?.user || {}), ...(latestStaff?.user || {}) },
    role: { ...(incomingStaff?.role || {}), ...(latestStaff?.role || {}) },
  };
  const staffPhone =
    staff?.user?.phone || staff?.user?.phoneNumber || staff?.phone || "";
  const fullProfileUrl = `${rootClientPath}/${businessUrl}/${staff?.url || ""}`;
  const derivedInitials = (() => {
    const explicit = String(staff?.initials || "").trim().toUpperCase();
    if (explicit) return explicit;
    const name = String(staff?.user?.username || "").trim();
    if (!name) return "-";
    const parts = name.split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] || "";
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] || "" : "";
    return (first + last || first || "-").toUpperCase();
  })();

  const profileRows = [
    { label: "Name", value: staff?.user?.username || "-" },
    { label: "Email", value: staff?.user?.email || "-" },
    { label: "Phone", value: staffPhone || "No phone" },
    { label: "Initials", value: derivedInitials },
    { label: "Role", value: staff?.role?.name || "-" },
  ];

  return (
    <Grid container spacing={2} sx={{ p: { xs: 1, md: 2 } }}>
      <Grid item xs={12}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            border: (t) => `1px solid ${t.palette.divider}`,
          }}
        >
          <Box
            sx={{
              px: { xs: 2, md: 3 },
              py: { xs: 2, md: 2.5 },
              background: "linear-gradient(135deg, #f8fbff 0%, #eef4fb 100%)",
              color: "#0f2133",
              borderBottom: "1px solid rgba(15,33,51,0.08)",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {staff?.user?.username || "Staff Profile"}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              <Chip
                label={staff?.role?.name || "No role"}
                size="small"
                sx={{ bgcolor: "#dce8f7", color: "#13324d", fontWeight: 700 }}
              />
              <Chip
                label={derivedInitials}
                size="small"
                sx={{ bgcolor: "#e8eff9", color: "#1f3d58", fontWeight: 700 }}
              />
            </Stack>
          </Box>

          <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Grid container spacing={1.25}>
              {profileRows.map((row) => (
                <Grid item xs={12} sm={6} key={row.label}>
                  <Paper
                    variant="outlined"
                    sx={{
                      px: 1.5,
                      py: 1.2,
                      borderRadius: 2,
                      height: "100%",
                      bgcolor: "#fbfdff",
                    }}
                  >
                    <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 700 }}>
                      {row.label}
                    </Typography>
                    <Typography sx={{ fontWeight: 700, mt: 0.25, wordBreak: "break-word" }}>
                      {row.value}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>

            <Paper variant="outlined" sx={{ mt: 1.25, p: 1.5, borderRadius: 2, bgcolor: "#f7fbff" }}>
              <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 700 }}>
                Personal Booking URL
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.5 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    flex: 1,
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {fullProfileUrl}
                </Typography>
                <Link href={fullProfileUrl} target="_blank" rel="noopener noreferrer">
                  <OpenInNew sx={{ fontSize: "1.05rem", verticalAlign: "middle" }} />
                </Link>
              </Box>
            </Paper>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default StaffProfile;
export {};
